namespace SolovisGateway.Admin.Organizations {

    export interface OrgConnectionListControlOptions extends Solovis.UI.BaseControlOptions {
        organizationId: number;
    }

    interface ConnectionData {
        id: number;
        name: string;
        status: string;
        domains: string;
        isReadOnly: boolean;
        createdAt: number;
    }

    export class OrgConnectionListControl extends Solovis.UI.BaseControl {

        private _organizationId: number;
        private _connectionList: Array<ConnectionData>;
        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options: OrgConnectionListControlOptions) {
            super(options);
            this._organizationId = options.organizationId;
        }

        public async doInitAsync(): Promise<void> {
            let response = await Solovis.Rpc.invoke("~/Organization/ListConnections", { organizationId: this._organizationId });
            this._connectionList = response.result.connections;
        }

        public doRender() {
            let self = this;

            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._connectionList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store
                },

                showColumnLines: false,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: true,
                width: "100%",

                columns: [
                    {
                        dataField: 'name',
                        dataType: 'string',
                        caption: 'Connection Name',
                        allowSorting: true
                    },
                    {
                        dataField: 'status',
                        dataType: 'string',
                        caption: 'Status',
                        allowSorting: true,
                        width: 150,
                        cellTemplate: function (container, options) {
                            let data = options.data;
                            self._buildStatusCell(container, data);
                        }
                    },
                    {
                        dataField: 'domains',
                        dataType: 'string',
                        caption: 'Domains',
                        allowSorting: true
                    },
                    {
                        dataField: 'createdAt',
                        dataType: 'date',
                        format: 'shortDateShortTime',
                        caption: 'Created',
                        allowSorting: true
                    },
                    {
                        caption: 'Actions',
                        allowSorting: false,
                        width: 150,
                        cellTemplate: function (container, options) {
                            let data = options.data;
                            self._buildActionsCell(container, data);
                        }
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");

            if (this._connectionList.some(connection => connection.isReadOnly)) {
                $("<p>")
                    .css({ "margin-top": "10px", "color": "#999" })
                    .text("Read-only connections were created by another organization that shares the domain. Contact that organization's admin to make changes.")
                    .appendTo(this.container);
            }
        }

        private _buildStatusCell(container, data: ConnectionData) {
            SsoConnectionStatusUi.appendStatusBadge(container, {
                status: data.status,
                isReadOnly: data.isReadOnly
            });
        }

        private _buildActionsCell(container, data: ConnectionData) {
            let self = this;
            let configureButton = new Solovis.UI.Buttons.Button({
                text: "Configure",
                size: "small",
                click: function () {
                    location.href = Solovis.resolveUrl("~/Organization/ConfigureConnection?organizationId=" + self._organizationId + "&connectionId=" + data.id);
                }
            });

            let buttonElement = configureButton.getElement();

            if (data.isReadOnly) {
                buttonElement.css({ "opacity": "0.65", "cursor": "not-allowed" });
                buttonElement.prop("disabled", true);
            }

            buttonElement.appendTo(container);
        }
    }
}
